<template>
  <section
    class="app-main"
    :class='$auth.check()?"active-margin-with-menu":""'
  >
    <div class="container is-fluid is-marginless app-content">
      <levelbar></levelbar>
      <transition
        mode="out-in"
        enter-active-class="fadeIn"
        leave-active-class="fadeOut"
        appear
      >
        <router-view class="animated"></router-view>
      </transition>
    </div>
  </section>
</template>

<script>
import Levelbar from './Levelbar';

export default {
  components: {
    Levelbar
  }
};
</script>

<style lang="scss">
@import '~bulma/sass/utilities/variables';
@import '~bulma/sass/utilities/mixins';

.app-main {
  padding-top: 50px;
  // margin-left: 180px;
  // transform: translate3d(0, 0, 0);
  &.active-margin-with-menu {
    margin-left: 240px;
  }

  @include mobile() {
    margin-left: 0 !important;
  }
}

.app-content {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// AppMain.vue?257b57aa